import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, Eye, Pencil, Trash2, MessageCircle } from "lucide-react";
import api from "@/lib/api";

const statusBadge = {
  active: "crm-badge crm-badge-green",
  inactive: "crm-badge crm-badge-gray",
  blocked: "crm-badge crm-badge-red",
};
const statusLabels = { active: "Ativo", inactive: "Inativo", blocked: "Bloqueado" };

export default function CustomerList() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      if (statusFilter) params.status = statusFilter;
      const { data } = await api.get("/customers", { params });
      setCustomers(data);
    } catch { /* */ }
    setLoading(false);
  };

  useEffect(() => { fetchCustomers(); }, [statusFilter]);
  const handleSearch = (e) => { e.preventDefault(); fetchCustomers(); };
  const handleDelete = async (id) => {
    if (!window.confirm("Tem certeza que deseja remover este cliente?")) return;
    await api.delete(`/customers/${id}`);
    fetchCustomers();
  };

  return (
    <div data-testid="customer-list-page">
      <div className="flex items-center justify-between mb-8">
        <h1 className="crm-heading">Clientes</h1>
        <Link to="/crm/customers/new" data-testid="add-customer-btn" className="crm-btn-primary">
          <Plus className="w-4 h-4" /> Novo Cliente
        </Link>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <form onSubmit={handleSearch} className="flex-1 relative">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: "var(--crm-text-dim)" }} />
          <input value={search} onChange={(e) => setSearch(e.target.value)} data-testid="customer-search"
            placeholder="Buscar por nome, email ou telefone..." className="crm-input pl-10" />
        </form>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} data-testid="customer-status-filter"
          className="crm-input" style={{ maxWidth: "200px" }}>
          <option value="">Todos os status</option>
          <option value="active">Ativo</option>
          <option value="inactive">Inativo</option>
          <option value="blocked">Bloqueado</option>
        </select>
      </div>

      <div className="crm-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="crm-table">
            <thead>
              <tr>
                <th>Nome</th><th>Email</th><th>Telefone</th><th>Status</th><th className="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                [...Array(3)].map((_, i) => (
                  <tr key={i}><td colSpan={5}><div className="h-5 rounded animate-pulse" style={{ background: "var(--crm-border)" }} /></td></tr>
                ))
              ) : customers.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-12" style={{ color: "var(--crm-text-dim)" }}>Nenhum cliente encontrado</td></tr>
              ) : (
                customers.map((c) => (
                  <tr key={c.id} data-testid={`customer-row-${c.id}`}>
                    <td className="primary">{c.name}</td>
                    <td>{c.email}</td>
                    <td>{c.phone || "—"}</td>
                    <td><span className={statusBadge[c.status] || statusBadge.active}>{statusLabels[c.status] || c.status}</span></td>
                    <td className="text-right">
                      <div className="flex items-center justify-end gap-1">
                        <Link to={`/crm/customers/${c.id}`} className="p-2 rounded-lg transition-colors" style={{ color: "var(--crm-text-muted)" }} title="Ver"><Eye className="w-4 h-4" /></Link>
                        <Link to={`/crm/customers/${c.id}/edit`} className="p-2 rounded-lg transition-colors" style={{ color: "var(--crm-text-muted)" }} title="Editar"><Pencil className="w-4 h-4" /></Link>
                        <Link to={`/crm/chat/${c.id}`} className="p-2 rounded-lg transition-colors" style={{ color: "var(--crm-text-muted)" }} title="Chat"><MessageCircle className="w-4 h-4" /></Link>
                        <button onClick={() => handleDelete(c.id)} className="p-2 rounded-lg transition-colors hover:text-red-400" style={{ color: "var(--crm-text-dim)" }} title="Remover"><Trash2 className="w-4 h-4" /></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-xs mt-3" style={{ color: "var(--crm-text-dim)" }}>{customers.length} cliente(s)</p>
    </div>
  );
}
